import { render, staticRenderFns } from "./InfoTab.vue?vue&type=template&id=af651f54"
import script from "./InfoTab.vue?vue&type=script&lang=js"
export * from "./InfoTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports